__turbopack_context__.v({
  "className": "caveat_1bc4140a-module__gfLrfW__className",
});
